import React from 'react';

interface WorkClockIconProps {
  fill?: string;
  className?: string;
}

export const WorkClockIcon: React.FC<WorkClockIconProps> = ({ fill = '#85ADAA', className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="94" height="81" viewBox="0 0 94 81" fill="none" className={className}>
    <path
      d="M53.5244 0.25C75.4816 0.25 93.3427 18.1129 93.3428 40.0674C93.3428 62.0218 75.4817 79.8896 53.5244 79.8896C40.7815 79.8895 28.7107 73.7178 21.2373 63.3799C20.5793 62.4682 20.7823 61.1928 21.6943 60.5342C22.6089 59.8727 23.8827 60.0797 24.541 60.9912C31.2507 70.2719 42.0845 75.8143 53.5244 75.8145C73.2327 75.8145 89.2645 59.781 89.2646 40.0752C89.2646 20.3698 73.2327 4.33008 53.5244 4.33008C42.2564 4.3302 31.6076 9.68858 24.8711 18.7031C24.8034 18.9005 24.708 19.0845 24.5869 19.249C24.4259 19.4677 24.2214 19.652 23.9873 19.791C23.4091 20.2534 22.6201 20.3666 21.9326 20.0801H5.00781C3.8807 20.0801 2.96875 19.1679 2.96875 18.041C2.96896 16.9139 3.88086 16.0029 5.00781 16.0029H21.8018C29.3169 6.11605 41.0803 0.250116 53.5244 0.25Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
    <path
      d="M53.5254 59.7612C54.6524 59.7613 55.5645 60.673 55.5645 61.8003V65.7788C55.5645 66.9055 54.6525 67.8178 53.5254 67.8179C52.3983 67.8179 51.4863 66.9056 51.4863 65.7788V61.8003C51.4863 60.6729 52.3984 59.7612 53.5254 59.7612Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
    <path
      d="M79.2334 38.0317L79.4424 38.0425C80.4711 38.1469 81.2725 39.014 81.2725 40.0708C81.2724 41.1975 80.3605 42.1098 79.2334 42.1099H75.252C74.125 42.1099 73.213 41.1975 73.2129 40.0708C73.2129 38.9434 74.125 38.0317 75.252 38.0317H79.2334Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
    <path
      d="M31.7988 38.0317C32.9259 38.0317 33.8379 38.9434 33.8379 40.0708C33.8378 41.1975 32.9259 42.1099 31.7988 42.1099H27.8203C26.6932 42.1099 25.7813 41.1975 25.7812 40.0708C25.7812 38.9434 26.6932 38.0317 27.8203 38.0317H31.7988Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
    <path
      d="M53.5254 12.3247C54.6525 12.3248 55.5645 13.2371 55.5645 14.3638V18.3423C55.5645 19.4696 54.6524 20.3813 53.5254 20.3813C52.3984 20.3813 51.4863 19.4697 51.4863 18.3423V14.3638L51.4971 14.1548C51.6015 13.1263 52.4689 12.3247 53.5254 12.3247Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
    <path
      d="M69.3877 22.7969C70.2182 22.0367 71.5084 22.0955 72.2686 22.9258C73.0286 23.7561 72.9702 25.0459 72.1406 25.8057L58.9766 37.8477C58.9175 37.9019 58.855 37.9509 58.791 37.9971C59.1561 38.8096 59.3623 39.7089 59.3623 40.6553C59.3623 44.2459 56.4412 47.167 52.8506 47.167C49.2602 47.1669 46.3398 44.2458 46.3398 40.6553C46.34 37.065 49.2603 34.1447 52.8506 34.1445C54.0198 34.1445 55.1168 34.4581 56.0664 35C56.1155 34.944 56.1683 34.8902 56.2246 34.8389L69.3877 22.7969ZM52.8506 38.2227C51.5093 38.2228 50.4181 39.3142 50.418 40.6553C50.418 41.9966 51.5092 43.0887 52.8506 43.0889C54.1922 43.0889 55.2842 41.9967 55.2842 40.6553C55.284 39.3141 54.1921 38.2227 52.8506 38.2227Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
    <path
      d="M53.5273 6.57495C71.999 6.57495 87.0273 21.6013 87.0273 40.073C87.0271 58.5444 71.9967 73.5699 53.5254 73.5701C35.0539 73.5701 20.0276 58.5444 20.0273 40.073C20.0273 34.4551 21.4458 28.8934 24.1338 23.991C30.0247 13.2491 41.287 6.57501 53.5273 6.57495ZM53.5254 10.6501C42.7763 10.6501 32.8826 16.511 27.708 25.948C25.3491 30.2503 24.1055 35.1334 24.1055 40.0701C24.1055 56.2925 37.3027 69.49 53.5254 69.49C69.7477 69.4898 82.9473 56.2923 82.9473 40.0701C82.9473 23.8478 69.7477 10.6503 53.5254 10.6501Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
    <path
      d="M17.1885 49.0864C18.3157 49.0864 19.2275 49.9987 19.2275 51.1255C19.2274 52.2528 18.3155 53.1646 17.1885 53.1646H3.06445C1.93744 53.1646 1.02548 52.2528 1.02539 51.1255C1.02539 49.9987 1.93733 49.0864 3.06445 49.0864H17.1885Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
    <path
      d="M15.7363 38.0591L15.9453 38.0698C16.9739 38.1744 17.7754 39.0418 17.7754 40.0981C17.7753 41.2256 16.8605 42.1372 15.7363 42.1372H2.28906C1.16206 42.1372 0.250094 41.2254 0.25 40.0981C0.25 38.9713 1.16195 38.0591 2.28906 38.0591H15.7363Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
    <path
      d="M17.3906 27.0325C18.5176 27.0325 19.4297 27.9441 19.4297 29.0715C19.4296 30.1986 18.5149 31.1106 17.3906 31.1106H8.20117C7.07419 31.1106 6.16221 30.1983 6.16211 29.0715C6.16211 27.9441 7.07418 27.0325 8.20117 27.0325H17.3906Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
  </svg>
);
